import axios from 'axios';
import store from '../store';
import setAuthToken from 'helpers/setAuthToken';
import { SET_CURRENT_USER } from 'actions/types';
// const url = "http://localhost:8000/api/v1"

export const baseUrl =
  process.env.REACT_APP_BASE_URL || 'https://dev.api.peerlesslms.com/api/v1';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('access');
      localStorage.removeItem('refresh');
      localStorage.removeItem('activeRole');
      setAuthToken(false);
      store.dispatch({ type: SET_CURRENT_USER, payload: {} });
      if (window.location.pathname !== '/signin') {
        window.location.href = '/signin';
      }
    }
    return Promise.reject(error);
  },
);

// This is the right one going forward
export const sendRequest = (
  endpoint,
  data = {},
  method = 'GET',
  contentType = 'application/json',
  dispatch,
) => {
  try {
    return axios({
      url: `${baseUrl}${endpoint}`,
      method: method,
      data: data,
      headers: {
        Accept: 'application/json',
        'Content-type': contentType,
        Authorization: localStorage.getItem('access')
          ? `Bearer ${localStorage.getItem('access')}`
          : '',
      },
      onUploadProgress: progressEvent => {
        const uploadedPercent =  parseInt(
          Math.round((progressEvent.loaded * 100) / progressEvent.total)
        )
        if(dispatch) dispatch({type:'IS_UPLOADING', payload:{percent: uploadedPercent}})
      }
    });
  } catch (error) {
    console.log(error.message);
  }
};
